<!-- 审批流程定义 -- 从表 -->
<template>
  <div>
    <m-table
      ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"117",
        name:"流程建模",
        parentId:"FLOW_ID", 
        parentName:"审批流程定义",
        parentPath:"/system/approvalFlow",
        dataClass:2,
        addClick,
      }'
      :filterWhere = '{FLOW_ID:$route.query.FLOW_ID}'
    >
    </m-table>
    <m-selectorcc :visible.sync="select" :select='{
      searchslotType: "",
      searchslottitle: "请选择角色",
      multiple: true,
      searchslotId: 105,
      searchslotkey: { ID: "ID", TEAM_NAME :"TEAM_NAME" },
    }' @listenEvent="fn"></m-selectorcc>
  </div>
</template>

<script>
import { addShow } from "@/api/table/table";
import MSelectorcc from "@/components/table/MSelectorcc";
export default {
  components: {
    MSelectorcc,
  },
  data() {
    return {
      firstEnter:true,
      select :false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 新增打开选择器
    addClick(){
      this.select = true;
    },
    // 选择器 回填
    fn(e){
      this.select = false;
      let total = this.$refs.table.$refs.child.data.length
      addShow({
          opid: 117,
          dataClass: 2,
          data: {
            TEAM_ID:e.ID.join(","),
            ITEM_NAME:e.TEAM_NAME.join(","),
            FLOW_ID:this.$route.query.FLOW_ID,
            METHOD_ID: 1,
            ITEM_SORT: total + 1
          },
          runId: this.$route.query.runId,
          otherCol:"TEAM_ID,ITEM_NAME"
        }).then(res=>{
        this.$refs.table.$refs.child.onLoad();
      });
    },
  },
  created() {},
  mounted() {},
  activated() {
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  },
};
</script>

<style></style>